import React from "react";
import { Route, Routes, Link } from "react-router-dom"; // Don't include Router here
import Header from "./components/Header";
import FeaturesSection from "./components/FeaturesSection";
import VideoSection from "./components/VideoSection";
import AppScreenshots from "./components/AppScreenshots";
import AppDownload from "./components/AppDownload";
import FAQ from "./components/Faq";
import Footer from "./components/Footer";
import RefundPolicy from "./components/company/RefundPolicy"; // Import the RefundPolicy component
import TermsAndCondition from "./components/company/TermsAndCondition";
import PrivacyPolicy from "./components/company/PrivacyPolicy";

function App() {
  return (
    <div>
      {/* <Header /> */}
      <Routes>
        {/* Add Route for RefundPolicy */}
        <Route path="/refundPolicy" element={<RefundPolicy />} />
        <Route path="/termsAndCondition" element={<TermsAndCondition />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />

        {/* Default Route for the other sections */}
        <Route path="/" element={
          <>
            <div id="header"><Header /></div>
            <div id="features"><FeaturesSection /></div>
            <div id="promo"><VideoSection /></div>
            <div id="screenshots"><AppScreenshots /></div>
            <div id="download"><AppDownload /></div>
            <div id="faq"><FAQ /></div>
            <div id="contact"><Footer /></div>
          </>
        } />
      </Routes>
    </div>
  );
}

export default App;
